import Vue from 'vue'
import App from './App.vue'

/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios

import './css/big.css'
/* Fine TerAs */
        

/* Inizio Router */
import router from'./router'
/* Fine Router */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('routerFirst', function(to) {

  axios.query('fetchAll',`SELECT * FROM codicefiscale.comune WHERE 1 ORDER BY nome`,{},teras,'_comune') 
  axios.query('fetchAll',`SELECT * FROM codicefiscale.provincia WHERE id>0 AND id !=111 ORDER BY nome`,{},teras,'_provincia')  
  axios.query('fetchAll',`SELECT id,regione AS nome FROM codicefiscale.provincia WHERE regione!='' GROUP BY regione ORDER BY regione`,{},teras,'_regione')  
  axios.query('fetchAll',`SELECT * FROM bm_bvent.nazione WHERE 1 ORDER BY id`,{},teras,'_nazione').then((response) =>  {
    teras.app.step++
  })


  /* Inizio teras-login */
  console.log("CONTROLLO SE PRESENTE UTENTE IN LOCAL STORAGE....")
  if(storage.exist('utente')){
    console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI..."+to.path)
    teras.utente = storage.load('utente')
    teras.event.emit('login')
  }else{
    socio.contatto.new().then(data=>{  
    //socio.contatto.load(2955).then(data=>{
      console.log(data)
      console.log("Aggiungo +1 per il controllo del utente")
      teras.app.step++
      teras.app.routeInitial = '/socio-edit'
    })
  }
  /* Fine teras-login */

  teras.app.routeInitial = to.path
})
teras.event.on('appReady', function() {
console.log("appReady appReady appReady appReady appReady appReady appReady")
router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
teras.event.on('login', function() {
  teras.app.auth = true
  storage.save("utente",teras.utente)
  socio.contatto.load(teras.utente).then(data=>{
    switch(parseInt(socio.contatto.row.step)) {
      case 0:
      teras.app.routeInitial = 'socio-edit'    
      break;
      case 1:
      teras.app.routeInitial = 'socio-pagamento'    
      break;
      case 2:
      teras.app.routeInitial = 'socio'    
      break;
      default:
      teras.app.routeInitial = 'page-error'    
  }


    console.log("Aggiungo +1 per il controllo del utente")
    teras.app.step++
  })
  if(teras.app.ready){
    console.log("APPREADYFROM LOGIN "+teras.app.routeInitial)
    router.push(teras.app.routeInitial)
  }
})
/* Fine TerAs-event */
        
import socio from './teras/socio'
Vue.prototype.$socio = socio
vueData.socio = socio  

new Vue({
  router,
  data:vueData,
  render: h => h(App)
}).$mount('#app')
